import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import useBoolean from "@hooks/useBoolean";
import { If } from "@componentsShared/Conditional/If";
import { AnimatePresence } from "framer-motion";
export var ExpandableText = function ExpandableText(_ref) {
  var children = _ref.children,
    _ref$showMoreText = _ref.showMoreText,
    showMoreText = _ref$showMoreText === void 0 ? 'Show More' : _ref$showMoreText,
    _ref$showLessText = _ref.showLessText,
    showLessText = _ref$showLessText === void 0 ? 'Show Less' : _ref$showLessText,
    containerClassName = _ref.containerClassName,
    _ref$haveShowMoreButt = _ref.haveShowMoreButton,
    haveShowMoreButton = _ref$haveShowMoreButt === void 0 ? true : _ref$haveShowMoreButt,
    _ref$haveShowLessButt = _ref.haveShowLessButton,
    haveShowLessButton = _ref$haveShowLessButt === void 0 ? true : _ref$haveShowLessButt,
    buttonClassName = _ref.buttonClassName;
  var expandable = useBoolean();
  return /*#__PURE__*/React.createElement(AnimatePresence, null, /*#__PURE__*/React.createElement("div", {
    className: twMerge("w-full", containerClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("line-clamp-2 overflow-hidden text-ellipsis", expandable.value && 'block overflow-visible'),
    style: expandable.value ? {} : {
      display: '-webkit-box',
      WebkitLineClamp: 2
    }
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: expandable.toggle,
    className: twMerge("mt-3 py-1 cursor-pointer text-blue-600 hover:text-blue-700 font-medium text-sm hover:underline", "transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded", buttonClassName)
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: expandable.value
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(If, {
    condition: haveShowLessButton
  }, showLessText)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(If, {
    condition: haveShowMoreButton
  }, showMoreText)))))));
};
export default ExpandableText;